import { render, staticRenderFns } from "./DeleteTemplateNoteHandwriting.vue?vue&type=template&id=c59a895c&scoped=true"
import script from "./DeleteTemplateNoteHandwriting.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateNoteHandwriting.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateNoteHandwriting.vue?vue&type=style&index=0&id=c59a895c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a895c",
  null
  
)

export default component.exports